<template>
  <div>
    <div v-if="showEdit">
      <v-card>
        <ApproveReceiptEdit
          :alldata="items"
          :editdata="editdata"
          v-if="!loading"
          @onsave="onsave"
          @close="showEdit = false"
          @onviewreceipt="getReceiptById"
        ></ApproveReceiptEdit>
      </v-card>
    </div>
    <div v-else>
      <!-- <div class="text-xs-center mt-4 mb-3" v-if="campaignLoading">
        <v-progress-circular indeterminate color="primary" size="50"></v-progress-circular>
      </div>
      <div v-else class="mb-2" style="display: flex; justify-content: start; flex-wrap: wrap">
        <div style="padding-top: 10px;">กรุณาเลือกแคมเปญ</div>
        <v-btn
          v-for="(item, index) in campaignList"
          @click="chooseCampaign(item)"
          :outline="selectCampaign.name != item.name"
          :color="selectCampaign.name == item.name ? 'primary' : 'grey'"
          :key="`campaign-${index}`"
          >{{ item.name }}</v-btn
        >
      </div> -->
      <div class="mb-2">
        <date-filter
          :filterlist="filterlist"
          @changeDate="onChangeDate"
          :defaultFilter="dateFilter"
          v-model="selectedDate"
        ></date-filter>
      </div>
      <v-layout row wrap class="pa-0 ma-0 mb-3">
        <v-flex xs4>
          <div>
            <v-btn outline @click="showsearch = true" :loading="loading"
              ><v-icon>search</v-icon>search</v-btn
            >
          </div>
        </v-flex>
        <v-flex xs8>
          <div class="text-xs-right">
            <span v-for="(item, k) in statusbuttons" :key="k">
              <v-btn v-if="item == status" depressed color="primary" style="border-radius: 4px">{{
                item
              }}</v-btn>
              <v-btn
                v-else
                @click="
                  status = item
                  onChangeDate()
                "
                color="grey"
                outline
                style="border-radius: 4px"
                >{{ item }}</v-btn
              >
            </span>
          </div>
        </v-flex>
      </v-layout>
      <v-btn :loading="exportloading" @click="exportxlsx" color="grey" outline>
        <em class="fas fa-file-export" />
        &nbsp;Export&nbsp;
      </v-btn>
      <br />
      <div class="text-xs-right">
        <v-pagination
          :total-visible="6"
          v-model="pageNumber"
          @input="changePage"
          :length="pagelength"
        ></v-pagination>
      </div>
      <br />
      <div>
        <div v-if="loading" class="text-xs-center">
          <scale-loader class="my-4" :loading="true" color="grey"></scale-loader>
        </div>
        <div v-else>
          <div v-if="!items.length">
            <div style="font-size: 22px" class="mt-4 grey--text text-xs-center">ไม่พบข้อมูล</div>
          </div>
          <div v-else>
            <v-card
              v-for="(item, k) in items"
              :key="k"
              class="pa-2 mb-3 pb-3"
              style="border-radius: 5px; border: 3px solid #1548a7; position: relative"
            >
              <div class="red--text" v-if="item.status == 'reject'" style="font-size: 13px">
                Rejected by {{ item.adminid }}
                <span
                  @click="showReason(item, true)"
                  style="text-decoration: underline; cursor: pointer"
                  >ดูสาเหตุ</span
                >
              </div>
              <div>
                <v-layout row wrap class="pa-0 ma-0 px-4">
                  <v-flex xs4 class="pt-3" style="font-size: 16px">
                    <div class="font-weight-bold">รายการเลขที่: {{ item.id }}</div>
                    <div>
                      <span>ชื่อลูกค้า : </span
                      >{{ item.userdata.firstName + ' ' + item.userdata.lastName }}
                    </div>
                    <div>
                      <span class="grey--text">ร้าน : </span>{{ item.store_name || '-' }}
                      <span class="grey--text">รหัสร้าน : </span>{{ item.store_id || '-' }}
                    </div>
                    <div class="caption">
                      {{ item.timestamp | DateFormat('DD/MM/YYYY HH:mm') }}&nbsp;&nbsp;{{
                        item.adminid || ''
                      }}
                    </div>
                  </v-flex>
                  <v-flex xs4 class="pt-5">
                    <div>เลขที่ใบเสร็จ: {{ item.ref_receipt ? item.ref_receipt : '-' }}</div>
                  </v-flex>
                  <v-flex xs4>
                    <div style="display: flex; justify-content: flex-end" class="text-xs-right">
                      <div
                        :style="{
                          width: '20px',
                          height: '20px',
                          'border-radius': '50%',
                          'background-color': statusCustom(item.status).color,
                          'margin-right': '5px'
                        }"
                      ></div>
                      <div>
                        <span :style="{ color: statusCustom(item.status).color }">{{
                          statusCustom(item.status).text
                        }}</span>
                      </div>
                    </div>
                    <div class="text-xs-right">
                      <v-btn @click="showAdminEdit(item)" class="px-5" color="primary" depressed
                        >กรอกข้อมูล</v-btn
                      >
                    </div>
                  </v-flex>
                </v-layout>
              </div>
            </v-card>
          </div>
        </div>
      </div>
    </div>

    <v-dialog v-model="showsearch" width="500px" persistent>
      <v-card>
        <div style="float: right">
          <v-btn @click="showsearch = false" icon><v-icon>close</v-icon></v-btn>
        </div>
        <div class="pa-2 pt-4 pb-3">
          <div style="font-weight: 600; font-size: 20px"><v-icon>search</v-icon> ค้นหา</div>
          <div>
            <v-layout class="pa-0 ma-0" wrap row>
              <v-flex xs12 sm6 class="form-control pa-1">
                <label>{{ $t('ชื่อลูกค้า') }}</label>
                <input v-model="filter.customer_name" class="form-control" type="text" />
              </v-flex>
              <v-flex xs12 sm6 class="form-control pa-1">
                <label>{{ $t('เลขใบเสร็จ') }}</label>
                <input v-model="filter.ref_no" class="form-control" type="text" />
              </v-flex>
              <v-flex xs12 sm12 class="form-control pa-1">
                <label>{{ $t('ร้านค้า') }}</label>
                <multiselect
                  placeholder="เลือกร้านค้า"
                  :show-labels="false"
                  label="store_name"
                  track-by="store_id"
                  v-model="filter.store"
                  :options="storeOptions"
                ></multiselect>
              </v-flex>
            </v-layout>
          </div>
          <div class="text-xs-center">
            <v-btn @click="clearsearch" outline color="grey">Clear</v-btn>
            <v-btn @click="onsearch" color="primary">Search</v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <div>
      <v-dialog v-model="showReasonDialog" persistent width="500px">
        <v-card v-if="showReasonDialog" class="px-5 pt-3 pb-3">
          <div class="text-xs-center" style="font-size: 18px; font-weight: bold; color: red">
            สาเหตุที่ Reject
          </div>
          <div class="mt-4" style="font-size: 16px">{{ currentreason }}</div>
          <div class="text-xs-center mt-3">
            <v-btn color="grey" outline @click="showReasonDialog = false">ปิด</v-btn>
          </div>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import importxlsx from '@/components/elements/importxlsx.vue'
// import exportxlsx from '@/components/elements/exportxlsx.vue'
import Multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import moment from 'moment'
import XLSX from 'xlsx'
import ApproveReceiptEdit from './ApproveReceiptEdit.vue'
import DateFilter from '@/components/view/dashboard/DateFilter.vue'
export default {
  components: {
    DateFilter,
    importxlsx,
    Multiselect,
    ApproveReceiptEdit,
    ScaleLoader
  },
  data() {
    return {
      selectedItems: [],
      currentreason: '',
      statusbuttons: ['all', 'pending', 'approved', 'reject', 'รอตรวจสอบ'],
      selectedDate: {
        start: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      },
      total: 0,
      offset: 0,
      limit: 10,
      pagetmp: 1,
      pageNumber: 1,
      importloading: false,
      showEdit: false,
      approveloading: false,
      editdata: '',

      columnName: '',
      items: [],
      status: 'all',
      filter: {
        ref_no: '',
        customer_name: '',
        store: ''
      },
      exportloading: false,
      showsearch: false,
      showReasonDialog: false,
      loading: true,
      storeOptions: [],
      campaignList: [],
      campaignLoading: false,
      filterlist: [
        { value: 'all', text: 'All' },
        { value: 'today', text: 'today' },
        { value: 'yesterday', text: 'yesterday' },
        { value: 'last_3_days', text: 'last {day} days', options: { day: 3 } },
        { value: 'last_7_days', text: 'last {day} days', options: { day: 7 } },
        { value: 'last_15_days', text: 'last {day} days', options: { day: 15 } },
        { value: 'this_month', text: 'this month' },
        { value: 'this_year', text: 'this year' },
        { value: 'last_month', text: 'last 30 days' },
        { value: 'last_365_day', text: 'last 365 days' },
        { value: 'custom_date', text: this.fullsize ? 'Custom Date' : 'Custom Date2' }
      ],
      dateFilter: 'last_7_days'
    }
  },
  computed: {
    storeName() {
      var store = this.$store.state.toaEcouponStore
      var currentStore = store.filter((el) => {
        return el.store_id == this.item.store_id
      })

      return currentStore[0].store_name
    },
    selectAll: {
      get: function () {
        if (this.items.length) {
          return this.items ? this.selectedItems.length == this.items.length : false
        } else return false
      },
      set: function (value) {
        var selected = []

        if (value) {
          this.items.forEach(function (item) {
            selected.push(item.id)
          })
        }

        this.selectedItems = selected
      }
    },
    filteredItems() {
      var result = [...this.items]
      const start = (this.pageNumber - 1) * this.limit
      const end = start + this.limit
      return result.slice(start, end)
    },
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        return Math.ceil(this.total / this.limit)
      } else {
        return 1
      }
    },
    selectCampaign() {
      return this.$store.state.selectToaCampaign
    }
  },
  async mounted() {
    // Set lang default for this component
    this.$i18n.set('th')
    this.loading = true
    Promise.all([this.getStore(), this.getProduct()])
    // this.getEnabledCampagin()
    await this.getData()

    let { transactionId } = this.$route.query
    if (transactionId) {
      await this.getReceiptById(transactionId)
    }

    this.loading = false
  },
  methods: {
    sumPrice(products) {
      return Math.floor(
        parseFloat(
          products.reduce((acc, cur) => {
            return acc + parseFloat(cur.price || 0) * parseFloat(cur.quantity)
          }, 0)
        )
      )
    },
    showReason(item, isAdmin = false) {
      this.currentreason = item.reject_reason
      this.showReasonDialog = true
    },
    onChangeDate(val) {
      this.dateFilter = val ? val.filter : 'last_7_days'
      this.getData(val)
    },
    statusCustom(status) {
      if (status == 'pending') {
        return { text: 'Pending', color: '#FFCC4A' }
      } else if (status == 'approved') {
        return { text: 'Approved', color: '#0AB826' }
      } else if (status == 'reject') {
        return { text: 'Reject', color: '#FF1414' }
      } else if (status == 'waiting_for_delivery') {
        return { text: 'รอตรวจสอบ', color: '#2584F2' }
      } else return { text: status, color: 'primary' }
    },
    async getData(options) {
      return new Promise((resolve) => {
        if (this.status == 'รอตรวจสอบ') {
          this.status = 'waiting_for_delivery'
        }

        var data = {
          pageid: this.selectedBot.pageid,
          start_time: this.selectedDate.start
            ? moment(this.selectedDate.start).format('YYYY-MM-DD')
            : undefined, // YYYY-MM-DD
          end_time: this.selectedDate.end
            ? moment(this.selectedDate.end).format('YYYY-MM-DD')
            : undefined, // YYYY-MM-DD
          status: this.status, // pending, approved, reject, waiting_for_delivery
          limit: this.limit,
          offset: this.offset,
          campaign_id: this.selectCampaign ? this.selectCampaign.id : null
        }

        if (this.dateFilter && this.dateFilter == 'all') {
          delete data.start_time
          delete data.end_time
        }

        for (const key in this.filter) {
          if (this.filter[key]) {
            if (key == 'store') {
              Object.assign(data, { store_id: this.filter[key].store_id })
            } else {
              Object.assign(data, { [key]: this.filter[key] })
            }
          }
        }
        this.loading = true
        api.getReceiptToaecoupon(data, (err, response) => {
          resolve()
          this.loading = false
          if (response.responsecode == 200) {
            this.items = response.data
            this.total = response.total
          }
        })
      })
    },
    async getProduct() {
      return new Promise((resolve) => {
        var data = {
          pageid: this.selectedBot.pageid
        }
        api.getAllProductsToaecoupon(data, (err, response) => {
          this.$store.state.toaEcouponProducts = response.data
          resolve()
        })
      })
    },

    clearsearch() {
      this.filter = {
        ref_no: '',
        customer_name: '',
        store_id: ''
      }
      this.getData()
      this.showsearch = false
    },
    onsearch() {
      this.getData()
      this.showsearch = false
    },
    async exportxlsx() {
      return new Promise((resolve) => {
        this.exportloading = true
        this.$store.dispatch('loading')

        var data = {
          pageid: this.selectedBot.pageid,
          start_time: this.selectedDate.start
            ? moment(this.selectedDate.start).format('YYYY-MM-DD')
            : undefined,
          end_time: this.selectedDate.end
            ? moment(this.selectedDate.end).format('YYYY-MM-DD')
            : undefined,
          status: this.status,
          limit: this.total,
          offset: 0,
          campaign_id: this.selectCampaign ? this.selectCampaign.id : null
        }
        if (this.dateFilter && this.dateFilter == 'all') {
          delete data.start_time
          delete data.end_time
        }
        for (const key in this.filter) {
          if (this.filter[key]) {
            if (key == 'store') {
              Object.assign(data, { store_id: this.filter[key].store_id })
            } else {
              Object.assign(data, { [key]: this.filter[key] })
            }
          }
        }
        api.getReceiptToaecoupon(data, (err, response) => {
          this.exportloading = false
          this.$store.dispatch('loading')
          if (response.responsecode == 200) {
            let items = response.data
            if (!items) {
              this.$swal.fire('ไม่สามารถ export ข้อมูลได้', 'เนื่องจากไม่มีข้อมูล', 'warning')
              return
            }

            // Export to xlsx
            const json = items.map((m, index) => {
              const part_1 = {
                รายการเลขที่: m.id,
                ชื่อลูกค้า: m.userdata ? m.userdata.firstName + ' ' + m.userdata.lastName : '',
                สถานะ: m.status == 'waiting_for_delivery' ? 'รอตรวจสอบ' : m.status,
                เลขที่ใบเสร็จ: m.ref_receipt,
                วันที่อ้างอิงในใบเสร็จ: m.ref_date,
                รหัสร้านค้า: m.store_id,
                ชื่อร้านค้า: m.store_name,
                วันที่อัปโหลดใบเสร็จ: m.timestamp ? moment(m.timestamp).format('DD/MM/YYYY') : '',
                เวลาอัปโหลดใบเสร็จ: m.timestamp ? moment(m.timestamp).format('HH:mm') : '',
                'เหตุผลในการ reject': m.reject_reason,
                แก้ไขโดย: m.adminid,
                อัพเดตเมื่อ: m.updated_timestamp
              }
              if (m.detail && m.detail.products) {
                const productDetails = m.detail.products.forEach((mp) => {
                  return {
                    รหัสสินค้า: mp.name.material_no,
                    ชื่อสินค้า: mp.name.product_name_th,
                    ขนาดสินค้า: mp.name.product_size,
                    ราคาต่อหน่วย: mp.price,
                    จำนวนสินค้า: mp.quantity,
                    ราคารวม: mp.total ? mp.total : mp.price * mp.quantity,
                    คูปองที่ได้รับ:
                      m.status == 'approved' && m.detail
                        ? m.detail.coupon
                            .map((mc) => {
                              return (
                                '{' +
                                ' หมายเลขคูปอง: ' +
                                mc.barcode +
                                ' , มูลค่า ' +
                                mc.amount +
                                ' }'
                              )
                            })
                            .toString()
                        : ''
                  }
                })
                return { ...part_1, ...productDetails }
              } else {
                return {
                  ...part_1,
                  รหัสสินค้า: '',
                  ชื่อสินค้า: '',
                  ขนาดสินค้า: '',
                  ราคาต่อหน่วย: '',
                  จำนวนสินค้า: '',
                  ราคารวม: '',
                  คูปองที่ได้รับ: ''
                }
              }
            })

            const wb = XLSX.utils.book_new()
            const dataWS = XLSX.utils.json_to_sheet(json)
            XLSX.utils.book_append_sheet(wb, dataWS, 'รายการใบเสร็จ')

            let productsRecords = []
            // let products = items.filter(d => ['approved', 'pending'].includes(d.status))

            items.forEach((m) => {
              if (m.detail && m.detail.products) {
                m.detail.products.forEach((p) => {
                  m.detail.coupon.forEach((c) => {
                    let row = {
                      รหัสสินค้า: p.name.material_no,
                      marketing_group: p.name.marketing_group,
                      sub_marketing_group: p.name.sub_marketing_group,
                      ชื่อสินค้า: p.name.product_name_th,
                      ขนาดสินค้า: p.name.product_size,
                      'ราคา ต่อหน่วย': p.price,
                      จำนวน: p.quantity,
                      ราคารวม: p.total
                        ? p.total
                        : (Number(p.price) * Number(p.quantity)).toFixed(2),
                      หมายเลขคูปอง: c.barcode,
                      มูลค่า: c.amount
                    }
                    productsRecords.push(row)
                  })
                })
              }
            })

            // products = json.map(m =>{
            //   return{
            //     ชื่อลูกค้า: m.ชื่อลูกค้า,
            //     รายละเอียดสินค้า: m.รายละเอียดสินค้า,
            //     คูปองที่ได้รับ: m.คูปองที่ได้รับ
            //   }
            // })
            const dataWs2 = XLSX.utils.json_to_sheet(productsRecords)
            XLSX.utils.book_append_sheet(wb, dataWs2, 'รายการสินค้า + คูปอง')

            let overallProductsRecords = []
            // let products = items.filter(d => ['approved', 'pending'].includes(d.status))

            items.forEach((m) => {
              let total = 0
              if (m.detail && m.detail.products) {
                total = m.detail.products.reduce((prev, curr) => {
                  return (
                    prev +
                    (curr.total
                      ? parseFloat(curr.total)
                      : parseFloat(curr.price) * parseFloat(curr.quantity))
                  )
                }, 0)
              }

              let vat = 0,
                vat_percentage = 0
              if (m.detail && m.detail.include_vat) {
                vat_percentage = 0.07
              }

              vat = total * vat_percentage
              let discount = m.detail && m.detail.discount ? parseFloat(m.detail.discount) : 0
              let amount = Math.ceil(total + vat) - discount

              let row = {
                รายการเลขที่: m.id,
                ชื่อลูกค้า: m.userdata ? m.userdata.firstName + ' ' + m.userdata.lastName : '',
                สถานะ: m.status == 'waiting_for_delivery' ? 'รอตรวจสอบ' : m.status,
                เลขที่ใบเสร็จ: m.ref_receipt,
                วันที่อ้างอิงในใบเสร็จ: m.ref_date,
                รหัสร้านค้า: m.store_id,
                ชื่อร้านค้า: m.store_name,
                วันที่อัปโหลดใบเสร็จ: m.timestamp ? moment(m.timestamp).format('DD/MM/YYYY') : '',
                เวลาอัปโหลดใบเสร็จ: m.timestamp ? moment(m.timestamp).format('HH:mm') : '',
                'เหตุผลในการ reject': m.reject_reason,
                แก้ไขโดย: m.adminid,
                อัพเดตเมื่อ: m.updated_timestamp,
                มูลค่ารวม: total ? total.toFixed(2) : 0,
                ภาษี: vat ? vat.toFixed(2) : 0,
                ส่วนลด: discount ? discount.toFixed(2) : 0,
                มูลค่ารวมทั้งหมด: amount ? amount.toFixed(2) : 0,
                คะแนนพิเศษ: m.special_score,
                คะแนน: m.sell_score,
                คะแนนรวม: m.score
              }
              overallProductsRecords.push(row)
            })

            const dataWs3 = XLSX.utils.json_to_sheet(overallProductsRecords)
            XLSX.utils.book_append_sheet(wb, dataWs3, 'สรุปรายการใบเสร็จ')

            XLSX.writeFile(wb, 'exportedReceiptData' + '.xlsx')
          }
          resolve()
        })
      })
    },
    async exportxlsxReceipt() {
      this.exportloading = true

      var json = this.exportDataReceipt
      const dataWS = XLSX.utils.json_to_sheet(json)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, 'exportedReceiptData' + '.xlsx')
      this.exportloading = false
    },
    async exportxlsxProducts() {
      this.exportloading = true
      var json = []

      var row = {
        start: 1,
        end: 0
      }

      var merge = []

      this.items.forEach((el, k) => {
        if (k) {
          row.start = row.end + 1
        }
        if (el.details && el.details.products.length) {
          row.end += el.details.products.length
          var points_by_product = this.points_by_product(el.details.products)
          el.details.products.forEach((product) => {
            json.push({
              ชื่อลูกค้า: el.first_name + ' ' + el.last_name,
              เบอร์โทรศัพท์: el.phone_number,
              อาชีพ: el.job,
              ห้าง: el.department_store,
              สาขา: el.branch,
              เลขที่ใบเสร็จ: el.details && el.details.ref_no ? el.details.ref_no : el.ref_no,
              'Ref.': el.details ? el.details.ref : '',
              วันที่ซื้อ: el.details ? moment(el.details.date).format('DD/MM/YYYY') : '',
              SKU: product.name.sku,
              รายการสินค้า: product.name.product_name,
              ราคา: product.price,
              จำนวน: product.quantity,
              ราคารวม:
                product.price && product.quantity
                  ? parseFloat(product.price) * parseFloat(product.quantity)
                  : 0,
              'ผู้ตรวจ (Admin)': el.admin,
              วันที่ตรวจ: el.verified_receipt_timestamp
                ? moment(el.verified_receipt_timestamp).format('DD/MM/YYYY')
                : '',
              คะแนนที่ได้จากบิลนี้: points_by_product
            })
          })
        } else {
          row.end++
          json.push({
            ชื่อลูกค้า: el.first_name + ' ' + el.last_name,
            เบอร์โทรศัพท์: el.phone_number,
            อาชีพ: el.job,
            ห้าง: el.department_store,
            สาขา: el.branch,
            เลขที่ใบเสร็จ: el.details && el.details.ref_no ? el.details.ref_no : el.ref_no,
            'Ref.': el.details ? el.details.ref : '',
            วันที่ซื้อ: el.details ? moment(el.details.date).format('DD/MM/YYYY') : '',
            SKU: '',
            รายการสินค้า: '',
            ราคา: '',
            จำนวน: '',
            ราคารวม: '',
            'ผู้ตรวจ (Admin)': '',
            วันที่ตรวจ: '',
            คะแนนที่ได้จากบิลนี้: ''
          })
        }
        merge.push(
          { s: { r: row.start, c: 0 }, e: { r: row.end, c: 0 } }, //ชื่อลูกค้า
          { s: { r: row.start, c: 1 }, e: { r: row.end, c: 1 } }, //เบอร์โทรศัพท์
          { s: { r: row.start, c: 2 }, e: { r: row.end, c: 2 } }, //อาชีพ
          { s: { r: row.start, c: 3 }, e: { r: row.end, c: 3 } }, //ห้าง
          { s: { r: row.start, c: 4 }, e: { r: row.end, c: 4 } }, //สาขา
          { s: { r: row.start, c: 5 }, e: { r: row.end, c: 5 } }, //เลขที่ใบเสร็จ
          { s: { r: row.start, c: 6 }, e: { r: row.end, c: 6 } }, //Ref.
          { s: { r: row.start, c: 7 }, e: { r: row.end, c: 7 } } //วันที่ซื้อ
        )
      })
      const dataWS = XLSX.utils.json_to_sheet(json)

      dataWS['!merges'] = merge
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, 'exportedReceiptData' + '.xlsx')
      this.exportloading = false
    },
    changePage(val) {
      if (this.pagetmp != val) {
        this.pagetmp = val
        this.offset = this.pageNumber * this.limit - this.limit
        if (this.pageNumber != 1) {
          this.offset + 1
        }
        this.getData()
      }
    },
    showAdminEdit(item) {
      this.editdata = item
      this.showEdit = true
    },
    async onsave() {
      this.showEdit = false
      this.loading = true
      await this.getData()
      this.loading = false
    },
    gotolink(link) {
      this.$nextTick(() => {
        window.location.href = link
      })
      // location.assign(this.qrlink)
    },
    async getStore() {
      return new Promise((resolve) => {
        var data = {
          pageid: this.selectedBot.pageid,
          campaign_id: this.selectCampaign ? this.selectCampaign.id : null
        }

        api.getAllStoreToaecoupon(data, (err, response) => {
          this.$store.state.toaEcouponStore = response.data
          this.storeOptions = response.data
          resolve()
        })
      })
    },
    async getReceiptById(id) {
      return new Promise((resolve) => {
        this.showEdit = false
        this.$store.dispatch('loading')
        let data = {
          id: id,
          pageid: this.selectedBot.pageid
        }

        api.getTOAECOUPONReceiptById(data, (err, response) => {
          this.$store.dispatch('loading')
          this.editdata = response.data
          this.showEdit = true
          resolve()
        })
      })
    },
    getEnabledCampagin() {
      this.campaignLoading = true
      let payload = {
        pageid: this.selectedBot.pageid,
        source: 'cms'
      }

      api.TOAECOUPONgetAllCampaign(payload, async (err, result) => {
        if (result.responsecode == 200) {
          this.campaignLoading = false
          this.campaignList = result.data
          if (this.campaignList && this.campaignList.length > 0) {
            this.selectCampaign = this.campaignList[0]
            await this.getData()
          }
        }
      })
    },
    chooseCampaign(campaign) {
      this.selectCampaign = campaign
      this.offset = 0
      this.getData()
    }
  }
}
</script>

<style lang="scss">
@import 'photoviewer/dist/photoviewer.css';
</style>



// WEBPACK FOOTER //
// src/components/view/template/toaecoupon/ApproveReceipt.vue